import axios from "axios";
import { authHeader } from "../utils/authHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export const list = (accessToken) => {
  return axios.get(apiUrl + "/category/all/1/1000", {
    headers: authHeader(accessToken),
  });
};

export const get = (id, accessToken) => {
  return axios.get(apiUrl + "/category/" + id, {
    headers: authHeader(accessToken),
  });
};

export const create = (name_en, name_ar, accessToken) => {
  return axios.post(
    apiUrl + "/category",
    { name_en, name_ar },
    {
      headers: authHeader(accessToken),
    }
  );
};

export const edit = (id, name_en, name_ar, accessToken) => {
  return axios.put(
    apiUrl + "/category/" + id,
    { name_en, name_ar },
    {
      headers: authHeader(accessToken),
    }
  );
};

export const deleteCategory = (id, accessToken) => {
  return axios.delete(apiUrl + "/category/" + id, {
    headers: authHeader(accessToken),
  });
};
